import Vue from 'vue';
import CSPLoader from '@/components/LoadingDialog.vue';

Vue.component('CSPLoader', CSPLoader);